/**
 * Free-gift automation: keeps exactly 1 free gift in the cart whenever the cart
 * holds at least one paid item, and removes it when it holds none (or when the
 * merchant disables the feature).
 *
 * The gift is a genuinely $0.00 product, so no discount code or Function is needed.
 */
(function () {
  var G = window.PEP_GIFT || {};
  if (!G.handle || !G.variantId) return;

  var QTY = 1; // 1 free gift per ORDER. For 1 per paid item, use the paid count.
  var TOAST_MS = 4500;
  var busy = false;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /** The cart page renders its line items server-side. */
  function isCartPage() {
    var main = document.getElementById('MainContent');
    return (main && main.dataset.template === 'cart') || /\/cart\/?$/.test(window.location.pathname);
  }

  function cartJs() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function post(url, body) {
    return fetch(root() + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().catch(function () {
        return {};
      });
    });
  }

  var toast;
  var toastTimer;

  function showToast(message) {
    if (!message) return;

    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'pep-gift-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');

      var icon = document.createElement('span');
      icon.className = 'pep-gift-toast__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '🎁';

      var text = document.createElement('p');
      text.className = 'pep-gift-toast__text';

      var close = document.createElement('button');
      close.className = 'pep-gift-toast__close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Dismiss');
      close.textContent = '✕';
      close.addEventListener('click', hideToast);

      toast.appendChild(icon);
      toast.appendChild(text);
      toast.appendChild(close);
      document.body.appendChild(toast);
    }

    toast.querySelector('.pep-gift-toast__text').textContent = message;

    // Force a reflow so the transition runs when re-showing an existing toast.
    void toast.offsetWidth;
    toast.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, TOAST_MS);
  }

  function hideToast() {
    if (toast) toast.classList.remove('is-visible');
  }

  function reconcile() {
    if (busy) return;
    busy = true;

    var added = false;

    return cartJs()
      .then(function (cart) {
        var gift = null;
        var paid = 0;

        (cart.items || []).forEach(function (item) {
          if (item.handle === G.handle) {
            gift = item;
          } else {
            paid += item.quantity;
          }
        });


        var enabled = G.enabled !== false;
        var want = enabled && paid > 0 ? QTY : 0;
        var have = gift ? gift.quantity : 0;

        if (have === want) return null;
        if (want === 0) return post('cart/change.js', { id: gift.key, quantity: 0 });

        // Don't pre-judge stock: `available` reflects inventory at render time
        // and goes stale, and a gift set to "continue selling when out of
        // stock" adds fine despite available:false. Let /cart/add.js decide —
        // a rejection is handled below.
        if (!gift) {
          added = true;
          return post('cart/add.js', { id: G.variantId, quantity: want });
        }

        return post('cart/change.js', { id: gift.key, quantity: want });
      })
      .then(function (changed) {
        if (!changed) return;

        // Shopify answers a rejected add with a JSON error body (e.g. sold
        // out) rather than throwing, so treat that as "nothing happened".
        if (changed.status && changed.status >= 400) return;

        // `added` is only true when the gift wasn't already in the cart, i.e.
        // the first add of an order. Every later add finds the gift present,
        // adds nothing, and shows no toast — the "don't pop up again" rule.
        if (added && G.showPopup !== false) showToast(G.message);

        // The cart page renders its lines server-side, so a gift line we just
        // added or removed would otherwise be missing or stale. Reload instead
        // of patching the DOM.
        if (isCartPage()) {
          window.location.reload();
          return;
        }

        // Source-tagged so the header/cart UI refreshes without re-triggering us.
        return cartJs().then(function (cart) {
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: { data: { itemCount: cart.item_count, source: 'pep-free-gift' } },
            })
          );
        });
      })
      .catch(function () {})
      .finally(function () {
        busy = false;
      });
  }

  document.addEventListener('cart:update', function (event) {
    var source = event.detail && event.detail.data && event.detail.data.source;
    if (source === 'pep-free-gift') return; // ignore our own event
    reconcile();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
